export default
{ icons: {
  comment_dots: {
    icon: 'fas fa-comment-dots',
    label: 'comment-dots',
  },
  envelope: {
    icon: 'fas fa-envelope',
    label: 'envelope',
  },
  hands_helping: {
    icon: 'fas fa-hands-helping',
    label: 'hands-helping',
  },
  assistive_listening_systems: {
    icon: 'fas fa-assistive-listening-systems',
    label: 'assistive-listening-systems',
  },
  chevron_circle_right: {
    icon: 'fas fa-chevron-circle-right',
    label: 'chevron-circle-right',
  },
  phone_square: {
    icon: 'fas fa-phone-square',
    label: 'phone-square',
  },
  record_vinyl: {
    icon: 'fas fa-record-vinyl',
    label: 'record-vinyl',
  },
  mobile: {
    icon: 'fas fa-mobile',
    label: 'mobile',
  },
  share: {
    icon: 'fas fa-share',
    label: 'share',
  },
  star: {
    icon: 'fas fa-star',
    label: 'start'
  },
  bookmark: {
    icon: 'fas fa-bookmark',
    label: 'bookmark'
  },
  external_link_square_alt: {
    icon: 'fas fa-external-link-square-alt',
    label: 'external-link-square-alt'
  },
},
};
